module.exports = __webpack_public_path__ + "static/logo32-427c0c3d59070dbe01d5a2848b1dc472.png";